import { useEffect, useRef } from 'react';

import { send } from '@actual-app/core/platform/client/connection';

import { useSyncedPref } from '#hooks/useSyncedPref';

import { categoriasGasto, cuadrar, marcarHistoria } from './escribirHistoria';
import { leerHistoria } from './historia';

/** Un poco después de abrir, para no pisar la sincronización inicial. */
const ESPERA = 4000;

/**
 * Una vez por sesión, si hay historia: lo nuevo de antes de Rumbo queda
 * revisado y cada mes de historia vuelve a cuadrar. Así, si se ha ordenado
 * algo de la historia (de la oculta a «Comida»), los sobres de aquellos
 * meses siguen en 0 y lo por repartir no se mueve.
 */
export function useCuadreHistoria() {
  const [raw] = useSyncedPref('historia');
  const hecho = useRef(false);
  useEffect(() => {
    const historia = leerHistoria(raw);
    if (!historia || hecho.current) {
      return;
    }
    const { inicio } = historia;
    hecho.current = true;
    const id = window.setTimeout(() => {
      void (async () => {
        try {
          await marcarHistoria(send, historia);
          const { list } = await send('get-categories');
          await cuadrar(send, inicio, categoriasGasto(list));
        } catch {
          // Se intenta otra vez en la próxima sesión.
        }
      })();
    }, ESPERA);
    return () => {
      window.clearTimeout(id);
      hecho.current = false;
    };
  }, [raw]);
}
